import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Modal, Image, message, Button } from "antd";
import { ReactComponent as CloseIcon } from "@/assets/icons/closeicon.svg";
import {
  requestWechatBindingQrcode,
  roundRobinAccountStatus,
  getAuthComnonThirdList,
  unbindUser,
} from "@/services/api";
import { useEffect } from "react";
let pay_timer = 0;
let qrcode_timer = 0;
let wechat_qrcode_timer = 0;

/**
 *  微信绑定弹窗
 * @param {Function} handlePhoneBind 手机号绑定事件
 * @param {Function} handleReloadList 重新加载列表数据
 * @returns
 */
const WechatBindingModal = forwardRef(
  ({ handlePhoneBind, handleReloadList, handleReloadAuthThirdList }, ref) => {
    const [wechatBindModalVisible, setWechatBindModalVisible] = useState({}); //是否打开手机号绑定弹窗

    // useEffect(() => {
    //   clearInterval(pay_timer);
    // }, []);

    useImperativeHandle(
      ref,
      () => {
        return {
          setModalVisible: (flag, wechatBindFlag, phone) => {
            setWechatBindModalVisible({
              open: flag,
              wechatBindFlag: wechatBindFlag || false,
              phone: phone || "",
            });
            //未绑定调用微信二维码
            if (!wechatBindFlag) {
              getWechatBindingQrcode();
            }
          },
        };
      },
      []
    );

    /**
     * 二维码倒计时
     * @param {Number} time 倒计时总时长(s)秒
     * @param {Function} fn
     * @returns
     */
    const countDown = (time, fn) => {
      fn && fn(time);
      var timer = setInterval(function () {
        time--;
        if (time === 0) {
          clearInterval(timer);
        }
        fn && fn(time);
      }, 1000);
      return timer;
    };

    /**
     * 获取公众号二维码
     */
    const getWechatBindingQrcode = () => {
      clearInterval(pay_timer);
      requestWechatBindingQrcode({ brand_id: 7 }).then((res) => {
        if (res.code === 200) {
          clearInterval(wechat_qrcode_timer);
          if (document.querySelector(".wechat_binding_modal .weixin-qrcode")) {
            document.querySelector(".wechat_binding_modal .weixin-qrcode").src =
              res?.data?.url;
          }
          //接口获取二维码成功之后开启二维码定时器
          let refreshQrcodeEle = document.querySelector(
            ".wechat_binding_modal .refresh-qrcode"
          );
          if (refreshQrcodeEle) {
            //二维码2分钟倒计时
            clearInterval(qrcode_timer);
            qrcode_timer = countDown(120, function (t) {
              refreshQrcodeEle.classList.add("d-none");
              if (t === 0) {
                clearInterval(qrcode_timer);
                //清除二维码轮询定时器
                clearInterval(pay_timer);
                refreshQrcodeEle.classList.remove("d-none");
              }
            });
            //点击刷新二维码重新调取接口获取二维码
            refreshQrcodeEle.addEventListener("click", () => {
              refreshQrcodeEle.classList.add("d-none");
              clearInterval(wechat_qrcode_timer);
              getWechatBindingQrcode();
            });
          }
          clearInterval(pay_timer);
          //轮询当前用户登录状态
          getRobinAccountStatus({
            session_id: res?.data?.session_id,
            type: 2,
          });
        }
      });
    };

    /**
     * //轮询公众号授权状态
     * @param {Object} data session_id: 公众号二维码返回的session_id， type: 1:登录 2: 绑定
     */
    const getRobinAccountStatus = (data) => {
      pay_timer = setInterval(() => {
        roundRobinAccountStatus(data)
          .then((res) => {
            if (res.code === 200) {
              clearInterval(pay_timer);
              message.success("绑定成功");
              handleReloadAuthThirdList();
              //刷新列表数据
              handleReloadList();
              setWechatBindModalVisible(false);
            } else if (res.code === 401412) {
              message.warn("该微信已绑定其他账号");
              clearInterval(pay_timer);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }, 3000);
    };

    /**
     * 解除用户绑定
     */
    const requestUbindUser = () => {
      //platform: 1=微信 2=qq 3=google 4=facebook 5=apple
      //点击微信解绑需要判断当前用户手机号是否存在，如果存在的话才可以解绑，不存在需要提示用去去绑定手机号
      unbindUser({ platform: "1" })
        .then((res) => {
          if (res.code === 200) {
            message.success("解绑成功");
            setWechatBindModalVisible({ open: false });
            handleReloadAuthThirdList();
            //刷新列表数据
            handleReloadList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    return (
      <Modal
        title={false}
        open={wechatBindModalVisible.open}
        closeIcon={<CloseIcon />}
        onCancel={() => {
          setWechatBindModalVisible({ open: false });
        }}
        width={508}
        centered
        maskClosable={false}
        className="wechat_binding_modal"
        footer={false}
      >
        {/* 这里分三种情况: 1: 已绑定微信(手机号存在), 点击解绑让用户解除微信绑定; 2: 已绑定微信(手机号不存在), 点击解绑提示用户去绑定手机号; 3: 未绑定微信，提示用户去绑定微信*/}
        {wechatBindModalVisible?.wechatBindFlag &&
        wechatBindModalVisible?.phone ? (
          <>
            <h4 className="title mb-4">解除微信绑定</h4>
            <div className="text-center">
              <p style={{ fontSize: "1rem" }} className="text-start mb-5">
                解绑后将无法使用该微信号登录此账号，请谨慎操作！
              </p>
              <Button
                className="btn btn-lg wechatBindBtn"
                onClick={requestUbindUser}
              >
                确认解绑
              </Button>
              <Button
                className="btn btn-lg text-white wechatBindBtn"
                type="primary"
                onClick={() => setWechatBindModalVisible({ open: false })}
              >
                暂不解绑
              </Button>
            </div>
          </>
        ) : wechatBindModalVisible?.wechatBindFlag &&
          !wechatBindModalVisible?.phone ? (
          <>
            <h4 className="title">手机号码绑定</h4>
            <div className="text-center">
              <p
                style={{ fontSize: "1rem" }}
                className="text-start bind-phone-text"
              >
                为保障您的账户安全，请先绑定手机号码，再进行微信解绑操作！
              </p>
              <Button
                className="btn btn-lg phoneBindBtn"
                type="primary"
                onClick={handlePhoneBind}
              >
                手机号码绑定
              </Button>
            </div>
          </>
        ) : (
          <>
            <h4 className="title">微信绑定</h4>
            <div className="wechat_img d-flex justify-content-center position-relative">
              <Image
                src="https://images.niuxuezhang.cn/imgs/timg.svg"
                preview={false}
                className="weixin-qrcode"
              ></Image>
              <div className="refresh-qrcode position-absolute top-50 text-center d-none">
                <img
                  src="https://images.niuxuezhang.cn/imgs/account-center/restart-fill.svg"
                  alt=""
                />
                <p className="mb-0 mt-1">点击刷新二维码</p>
              </div>
            </div>
            <div className="text-center d-flex align-items-center justify-content-center">
              <img
                src="https://images.niuxuezhang.cn/imgs/account-center/wechat.svg"
                alt=""
              />
              <span className="ms-2 text-muted">
                微信扫码关注公众号进行绑定
              </span>
            </div>
          </>
        )}
      </Modal>
    );
  }
);

export default WechatBindingModal;
